var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"180px","width":"100%"},attrs:{"id":"alertChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }